import withLoader from "../../../components/layouts/WithLoader";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@material-ui/core";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import RateService from "../../../services/RateService";
import { update } from "immutability-helper";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import SocieteService from "../../../services/Societe";
import ChargeService from "../../../services/ChargesPayement/ChargeService";
import UploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import { useNavigate } from "react-router-dom";
import CashRegisterService from "../../../services/ProductSellBToC/CashRegisterService";
import ShopService from "../../../services/PosService/ShopService";

const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const AddCharge = ({ startLoading, stopLoading }) => {
  const animatedComponents = makeAnimated();
  const [allYears, setAllYears] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [monthPlaceholder, setMonthPlaceholder] = useState("Choisir...");
  const [monthsOptions, setMonthsOptions] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [finalMonth, setFinalMonth] = useState("");
  const [yearSelectedOption, setYearSelectedOption] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [yearSelected, setYearSelected] = useState(null);
  const [yearSelectPlaceHolder, setYearSelectPlaceHolder] =
    useState("Choisir...");
  const [availableRates, setAvailableRates] = useState([]);
  const [allRates, setAllRates] = useState([]);
  const [rateTableData, setRateTableData] = useState([]);
  const [selectedOptionRate, setSelectedOptionRate] = useState(null);
  const [rateSelectPlaceHolder, setRateSelectPlaceHolder] =
    useState("Choisir une charge");
  const [rateChoosen, setRateChoosen] = useState(null);
  const [valueRate, setValueRate] = useState();
  const [rateName, setRateName] = useState("");
  const [rateCode, setRateCode] = useState("");
  const [rateType, setRateType] = useState("");
  const [title, setTitle] = useState("");

  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const [infoAlertText, setInfoAlertText] = useState();
  const [description, setDescription] = useState("");
  const [fileNameDownloaded, setFileNameDownloaded] = useState("");
  const [fileDownloaded, setFileDownloaded] = useState([]);

  const navigate = useNavigate();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [magasinSelectedOption, setMagasinSelectedOption] = useState(null);
  const [magasinId, setMagasinId] = useState(0);
  const [allMagasin, setAllMagasin] = useState([{ value: 0, label: "aucun" }]);
  const [magasinSelectPlaceHolder, setMagasinSelectPlaceHolder] =
    useState("aucun");
  const onChangeSelectedMagasin = (selectedOptionn) => {
    setSelectedOption("");
    setMagasinId(selectedOptionn.value);
    setMagasinSelectedOption(selectedOptionn.label);
    setMagasinSelectPlaceHolder(selectedOptionn.label);
  };
  useEffect(() => {
    SocieteService.getFinacialYearsAndMonthsFromSocieteCreationDate()
      .then((response) => {
        if (response.data["success"] !== undefined) {
          const today = new Date();
          const mm = String(today.getMonth() + 1).padStart(2, "0");
          const yyyy = today.getFullYear();
          setYearSelected(yyyy);
          setYearSelectPlaceHolder(yyyy);
          if (mm === "01") {
            setFinalMonth("01");
            setMonthPlaceholder("Janvier");
          } else if (mm === "02") {
            setFinalMonth("02");
            setMonthPlaceholder("Février");
          } else if (mm === "03") {
            setFinalMonth("03");
            setMonthPlaceholder("Mars");
          } else if (mm === "04") {
            setFinalMonth("04");
            setMonthPlaceholder("Avril");
          } else if (mm === "05") {
            setFinalMonth("05");
            setMonthPlaceholder("Mai");
          } else if (mm === "06") {
            setFinalMonth("06");
            setMonthPlaceholder("Juin");
          } else if (mm === "07") {
            setFinalMonth("07");
            setMonthPlaceholder("Juiliet");
          } else if (mm === "08") {
            setFinalMonth("08");
            setMonthPlaceholder("Aout");
          } else if (mm === "09") {
            setFinalMonth("09");
            setMonthPlaceholder("Septembre");
          } else if (mm === "10") {
            setFinalMonth("10");
            setMonthPlaceholder("Octobre");
          } else if (mm === "11") {
            setFinalMonth("11");
            setMonthPlaceholder("Novembre");
          } else if (mm === "12") {
            setFinalMonth("12");
            setMonthPlaceholder("Decemebre");
          }
          const yearsOptions = response.data["success"].years.map(
            (year, index) => ({
              value: year,
              label: year,
            })
          );
          setAllYears([...yearsOptions]);
          const orderedMonth = response.data["success"].months.map((month) =>
            parseInt(month)
          );
          orderedMonth.sort((a, b) => a - b);
          setMonthsOptions([
            { value: "01", label: "Janvier" },
            { value: "02", label: "Février" },
            { value: "03", label: "Mars" },
            { value: "04", label: "Avril" },
            { value: "05", label: "Mai" },
            { value: "06", label: "Juin" },
            { value: "07", label: "Juillet" },
            { value: "08", label: "Aout" },
            { value: "09", label: "Septembre" },
            { value: "10", label: "Octobre" },
            { value: "11", label: "Novembre" },
            { value: "12", label: "Decembre" },
          ]);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : " + error);
      });
    if (localStorage.getItem("status").includes("ADMIN")) {
      CashRegisterService.getAllShop(getCurrentUserId())
        .then((response) => {
          if (response.data.success) {
            response.data.success.map((element) => {
              setAllMagasin((oldArray) => [
                ...oldArray,
                { value: element.id, label: element.name },
              ]);
            });
            // setAvailableShop(response.data.success);
          } else {
            console.log("error in getAllShop", response.data.success);
          }
        })
        .catch((e) => {
          console.log("error in getAllShop", e);
        });
    } else if (localStorage.getItem("status").includes("DIRECTEUR_MAGASIN")) {
      ShopService.getAllShopByManager(getCurrentUserId())
        .then((response) => {
          if (response.data.success) {
            response.data.success.map((element) => {
              setAllMagasin((oldArray) => [
                ...oldArray,
                { value: element.id, label: element.name },
              ]);
            });
          } else if (response.data.error) {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : " + response.data.error);
          }
        })
        .catch((e) => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : " + e);
          console.log("error in getAllShop", e);
        })
        .finally(() => {
          stopLoading();
        });
    }
  
    setAllRates([]);
    startLoading();
    RateService.getAllRatesByIdUserAndIsDeleted(getCurrentUserId(), 0)
      .then((result) => {
        result.data["success"].map((element, i) => {
          setAllRates((oldArray) => [
            ...oldArray,
            {
              value: element.id,
              label: element.code + "-" + element.name,
            },
          ]);
        });
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);
  const onChangeSelectedYear = (selectedOptionn) => {
    setSelectedOption();
    setYearSelected(selectedOptionn.value);
    setYearSelectPlaceHolder(selectedOptionn.label);
  };
  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption);
    setFinalMonth(selectedOption.value);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const onChangeValueRateHandler = (event) => {
    setValueRate(event.target.value);
  };
  const onChangeSelected = (selectedOption) => {
    console.log("selected", selectedOption);
    setSelectedOptionRate(selectedOption);
    setRateChoosen(selectedOption.value);
    setRateSelectPlaceHolder(selectedOption.label);
  };

  const blocRates = () => {
    if (rateChoosen !== null) {
      return (
        <>
          <div className="col-md-6">
            <label>Valeur:</label>
            <input
              onChange={onChangeValueRateHandler}
              type="number"
              value={valueRate}
              min="0"
              id="unitPrice"
              className="form-control"
            />
          </div>
        </>
      );
    }
  };

  const onAddTaxeToList = (event) => {
    let exist = false;
    let indexInRateTable;
    try {
      rateTableData.forEach((element, index) => {
        console.log("element", element);
        if (element.idRate === rateChoosen) {
          indexInRateTable = index;
          exist = true;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }
    if (rateChoosen === null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Sélectionnez une charge ");
    }
    if (valueRate == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le valeur est vide ! ");
    } else {
      if (!exist) {
        setRateTableData((previoustate) => [
          ...previoustate,
          {
            idRate: rateChoosen,
            name: rateSelectPlaceHolder,
            price: valueRate,
          },
        ]);
      } else if (exist) {
        let rateUpdateValue = rateTableData[indexInRateTable];
        if (rateTableData[indexInRateTable].price !== valueRate) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé la valeur de " + rateSelectPlaceHolder
          );
        }
        rateUpdateValue.idRate = rateChoosen;
        rateUpdateValue.name = rateSelectPlaceHolder;
        rateUpdateValue.price = valueRate;

        let modelData = update(rateTableData, {
          [indexInRateTable]: { $merge: rateUpdateValue },
        });

        setRateTableData(modelData);
      }
      setRateChoosen(null);
      setRateSelectPlaceHolder("choisir une charge");

      setValueRate("");
    }
  };
  const blocButtonAddRates = () => {
    if (rateChoosen !== null) {
      return (
        <div className="row">
          <div className="col-md-8"></div>
          <div className="col-md-4">
            <button class="btn btn-dark  float-right" onClick={onAddTaxeToList}>
              <i class="fas fa-plus"></i>
              Ajouter charge
            </button>
          </div>
        </div>
      );
    }
  };

  const columnsRate = [
    {
      dataField: "name",
      text: "Libellé",
      align: "center",
      headerAlign: "center",
    },

    {
      dataField: "price",
      text: "Valeur",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "idRate",
      text: "Supprimer",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button className="btn btn-danger">
            <i class="fas fa-trash"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("rateTableData cell", rateTableData);

          setRateTableData(
            rateTableData.filter((item) => item.idRate !== row.idRate)
          );
        },
      },
    },
  ];

  const handleNext = () => {
    if (title === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : le titre  est vide ");
    } else if (description === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : la description est vide ");
    } else if (rateTableData.length === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : aucune charge ");
    } else {
      let chargeModel = {
        idUser: getCurrentUserId(),
        chargeValuesModel: rateTableData,
        month: finalMonth,
        year: yearSelected,
        name: title,
        magasinId: magasinId,
        description: description,
      };
      if (fileDownloaded.length !== 0) {
        const uploadData = new FormData();
        uploadData.append("picture", fileDownloaded);

        UploadAndDownloadService.uploadFile(
          "/retail/uploadFile/uploadFile/Charge",
          uploadData
        )
          .then((response) => {
            if (response.data["success"]) {
              chargeModel.urlFileDownload = response.data.success;
              ChargeService.addChargeEtat(chargeModel)
                .then((result) => {
                  if (result.data.success) {
                    setOpenSuccessAlert(true);
                    setSuccessAlertText("Enregistrement avec succées");
                    setTimeout(() => {
                      navigate(`/payerCharges`);
                    }, 2000);
                  }
                })
                .catch((error) => {
                  setOpenErrorAlert(true);
                  setErrorAlertText("Erreur :" + error);
                });
            }
          })
          .catch((error) => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :" + error);
          })
          .finally(() => {
            stopLoading();
          });
      } else {
        startLoading();
        ChargeService.addChargeEtat(chargeModel)
          .then((result) => {
            if (result.data.success) {
              setOpenSuccessAlert(true);
              setSuccessAlertText("Enregistrement avec succées");
              setTimeout(() => {
                navigate(`/chargesEtat`);
              }, 2000);
            }
          })
          .catch((error) => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :" + error);
          })
          .finally(() => {
            stopLoading();
          });
      }
    }
  };

  function handleTableChangeRate({ rateTableData }) {
    return rateTableData;
  }

  const onChangeDescriptionHandler = (event) => {
    setDescription(event.target.value);
  };

  const onChangeTitleHandler = (event) => {
    setTitle(event.target.value);
  };
  const onUploadFileDownloadedHandler = (e) => {
    console.log(e.target.files);

    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setFileNameDownloaded(e.target.files[0].name);

      setFileDownloaded(e.target.files[0]);
    }
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="card card-dark">
            <div className="card-body">Ajouter Charge</div>
          </div>
        </div>
      </section>

      <section className="content-header">
        <div className="container-fluid">
          <div className="card card-dark">
            <div className="card-header">
              <h3 className="card-title"> Ajouter une charge </h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div className="col-sm-3">
                  <div className="form-group">
                    <label htmlFor="inputClientCompany">
                      Titre de la charge <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      value={title}
                      required="required"
                      onChange={onChangeTitleHandler}
                      type="text"
                      id="title"
                      className="form-control"
                      placeholder="Saisir..."
                    />
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="form-group">
                    <label htmlFor="inputClientCompany">
                      Choisir le magasin
                    </label>
                    <Select
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      defaultValue={magasinSelectedOption}
                      onChange={onChangeSelectedMagasin}
                      options={allMagasin}
                      placeholder={magasinSelectPlaceHolder}
                    />
                  </div>
                </div>
                <div className="form-group col-sm-3">
                  <label>Choisir le mois</label>
                  <Select
                    value={selectedMonth}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    options={monthsOptions}
                    onChange={handleMonthChange}
                    defaultValue={selectedMonth}
                    placeholder={monthPlaceholder}
                  />
                </div>
                <div className="form-group col-sm-3">
                  <label>Choisir l'année </label>
                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={yearSelectedOption}
                    onChange={onChangeSelectedYear}
                    options={allYears}
                    placeholder={yearSelectPlaceHolder}
                  />
                </div>
              </div>
              <div class="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputDescription">
                      Note <span style={{ color: "red" }}>*</span>
                    </label>
                    <textarea
                      value={description}
                      placeholder="Saisir..."
                      onChange={onChangeDescriptionHandler}
                      id="inputDescription"
                      className="form-control"
                      rows={4}
                      defaultValue={""}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Ajouter le fichier à déposer </label>
                    <div className="input-group">
                      <div className="custom-file">
                        <input
                          accept="application/pdf, .jpg, .jpeg, .png"
                          type="file"
                          className="custom-file-input"
                          id="exampleInputFile"
                          onChange={(event) => {
                            onUploadFileDownloadedHandler(event);
                          }}
                        />
                        <label
                          className="custom-file-label"
                          for="exampleInputFile"
                        >
                          {fileNameDownloaded}{" "}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-sm-6">
                  <div className="form-group">
                    <label>
                      Ajouter la quitance{" "}
                    </label>
                    <div className="input-group">
                      <div className="custom-file">
                        <input
                          accept="application/pdf, .jpg, .jpeg, .png"
                          type="file"
                          className="custom-file-input"
                          id="exampleInputFileUploaded"
                          onChange={(event)=>{
                            onUploadFileUploadedHandler(event)
                          }}
                        />
                        <label className="custom-file-label" for="exampleInputFileUploaded">
                          {fileNameUploaded}{" "}
                        </label>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
              <div class="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Choisir une charge</label>
                    <Select
                      styles={styles}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      defaultValue={selectedOptionRate}
                      onChange={onChangeSelected}
                      options={allRates}
                      placeholder={rateSelectPlaceHolder}
                    />
                  </div>
                </div>
                {blocRates()}
              </div>
              {blocButtonAddRates()}
              <br />
              <div className="row">
                <div className="col-md-12">
                  {rateTableData && (
                    <ToolkitProvider
                      keyField="rateTable"
                      data={rateTableData}
                      columns={columnsRate}
                      onTableChange={handleTableChangeRate}
                    >
                      {(props) => (
                        <div>
                          <div className="row">
                            <BootstrapTable
                              {...props.baseProps}
                              striped
                              hover
                              condensed
                            />
                          </div>
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </div>
              </div>
            </div>
            <div class="card-footer" style={{ marginTop: "1%" }}>
              <button class="btn btn-dark float-right" onClick={handleNext}>
                Valider
              </button>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(AddCharge);
